import {
  ArrayFilters,
  DefaultFilters,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const partnershipLinkFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'partnershipCompanyNameLike',
    label: '제휴사 명',
    placeholder: '제휴사 명을 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'postedAt',
    label: '게시 시작 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['startedAtFrom', 'startedAtTo'],
  },
  {
    key: 'urlCodeLike',
    label: 'URL code',
    placeholder: 'URLcode를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'adminNameLike',
    label: '등록 관리자',
    placeholder: '등록 관리자를 입력해주세요',
    type: 'TEXT',
  },
];
